<template>
    <div>
        <section class="mb-8">
            <h4 class="text-slate-800 dark:text-slate-100 font-medium mb-4">Your Stay</h4>
            <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-4">
                <div class="col-span-1">
                    <p class="text-slate-500 dark:text-slate-400 text-sm whitespace-nowrap">
                        Check in - out
                    </p>
                </div>
                <div class="col-span-2">
                    <p class="text-slate-800 dark:text-slate-100 text-sm">
                        <span v-if="!hideSensitiveData">
                            {{ dayjs(activeRedemption.start_date).format('MMM D') }}
                            <span v-if="activeRedemption.end_date">
                                -
                                {{ dayjs(activeRedemption.end_date).format('MMM D, YYYY') }}
                            </span>
                        </span>
                        <span v-else class="text-slate-400">Hidden</span>
                    </p>
                </div>
            </div>
        </section>

        <section class="mb-8" v-if="activeRedemption.hotel">
            <h4 class="text-slate-800 dark:text-slate-100 font-medium mb-4">Location</h4>
            <Map
                class="mb-2"
                :classes="'h-36'"
                :latitude="activeRedemption.hotel?.latitude"
                :longitude="activeRedemption.hotel?.longitude"
            />
            <address
                class="text-slate-500 dark:text-slate-400 text-sm not-italic"
                v-if="
                    activeRedemption.hotel?.address_1 ||
                    activeRedemption.hotel?.postal_code
                "
            >
                {{ activeRedemption.hotel?.address_1 }},
                {{ activeRedemption.hotel?.locality }}
                {{ activeRedemption.hotel?.region }}
                {{ activeRedemption.hotel?.postal_code }},
                {{ activeRedemption.hotel?.country }}
            </address>
        </section>
    </div>
</template>
<script setup>
import Map from '@/components/trips/redemptions/panel-partials/map.vue';
import dayjs from 'dayjs';

const props = defineProps({
    activeRedemption: Object,
    isSharedView: {
        type: Boolean,
        default: false,
    },
    hideSensitiveData: {
        type: Boolean,
        default: false,
    },
});
</script>
